export const hideLogoutDialog = () => {
  return { type: "DIALOG_LOGOUT_HIDE" }
}

export const showLogoutDialog = () => {
  return { type: "DIALOG_LOGOUT_SHOW" }
}
